import React, { useState, useEffect } from 'react';
import { UserService } from '../../services/UserService';
import style from './index.module.css';

const UserList = () => {
    const [users, setUsers] = useState([]);
    
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await UserService.getAllUsers();
                setUsers(data);
                console.log(data)
            } catch (error) {
                console.error('Failed to load users:', error);
            }
        };

        fetchUsers();
    }, []);

    const handleDeleteUser = async (id) => {
        if (!id) {
            console.error('İstifadəçi ID-si yoxdur');
            return;
        }
    
        try {
            await UserService.deleteUser(id);  
            setUsers(users.filter(user => user.userId !== id));
        } catch (error) {
            console.error('İstifadəçi silinərkən səhv baş verdi:', error);
        }
    };
    

    return (
        <div className="container mt-5">
            <h1 className={style.list}>User List</h1>
            <table className="table table-striped table-bordered">
                <thead className="thead-dark">
                    <tr>
                        <th>Full Name</th>
                        <th>UserEmail</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.userId}>
                            <td>{user.userFullName}</td>
                            <td>{user.email}</td>
                            <td>{user.userStatusName}</td>
                            <td>
                                <button 
                                    className="btn btn-danger"
                                    onClick={() => handleDeleteUser(user.userId)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UserList;

                // <div className={style.text} style={{ display: visibleDiv === 1 ? "block" : "none" }}>                     
                //                     <h6>Hello {user?.userName} (not <span>{user?.userName}?</span> <button onClick={handleLogout}>LogOut</button>)</h6>                     
                //                     <p>From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.</p>                 
                //                 </div>  